class SubcolCarousel extends HTMLElement {
    constructor() {
    super();

    this.selector = this.dataset.selector;
  }

  connectedCallback() {
    
    const config = {
      loop: false,
      dots: false,
      arrows: false,
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: 2.5,
        },
        750: {
          slidesPerView: 3.5,
        },
        800: {
          slidesPerView: 5,
        }
      },
    };

    new Swiper("#swiper-" + this.selector, config);
  }
}
customElements.define('subcol-carousel', SubcolCarousel);